export default "__VITE_ASSET__0b1ef692__"